import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { useFetchVersionList } from "../../api/hooks/useFetchVersion";
import { routes } from "../../routes/routes";
import { RootState } from "../../store/store";
import { getHeaderTextColor } from "../../utils/cssVariables";
import "./VersionLink.css";

export const VersionLink = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user.user);
  const isLoggedIn = !!user && user.id !== 0;
  const { data, isLoading, isError } = useFetchVersionList(isLoggedIn);

  if (!isLoggedIn) {
    return null;
  }

  if (location.pathname === routes.VERSION || location.pathname.startsWith(`${routes.VERSION}/`)) {
    return null;
  }

  const latestVersion = data?.latest || data?.releases?.[0]?.version;

  if (isLoading || (!latestVersion && !isError)) {
    return null;
  }

  const label = latestVersion ? `v${latestVersion}` : t("version_page.link_label");

  return (
    <Link
      to={routes.VERSION}
      state={{ from: location.pathname }}
      className="version-link"
      style={{ color: getHeaderTextColor() }}
      aria-label={
        latestVersion
          ? t("version_page.link_aria_label_with_version", { version: latestVersion })
          : t("version_page.link_aria_label")
      }
    >
      {label}
    </Link>
  );
};
